/**
 * Created by valera.siestov on 24.03.2015.
 */

if (!window.module) {
    window.module = {};
}

/**
 * Check form validate
 *
 * @class Validate
 *
 * @constructor
 */
module.validation = (function () {

    "use strict";

    var Validate = function () {

        /**
         * get error message
         *
         * @param input
         * @returns boolean
         */
        function getErrorMessage(input) {

            function defaultCheck(value) {
                var result = true;

                if (!value.trim().length) {
                    result = false;
                }

                return result;
            }

            function selectCheck(input) {

                var value,
                    result = true,
                    currentSelected,
                    select;


                if ($(input).hasClass('ui-selectmenu')) {
                    currentSelected = $(input).attr('id');
                    select = document.getElementById(currentSelected.replace('-button', ''));

                    value = select.options[select.selectedIndex].value;
                } else {
                    value = input.querySelector('input').value;
                }

                if (!value.length) {
                    result = false;
                }

                return result;
            }

            function emailCheck(value) {
                var validMail = /^[\-._a-z0-9]+@(?:[a-z0-9][\-a-z0-9]+\.)+[a-z]{2,6}$/i.test(value),
                    result = true;

                if (!validMail) {
                    result = false;
                }

                return result;
            }

            function numberCheck(value) {
                var defaultResult = defaultCheck(value);

                if (defaultResult) {
                    return !isNaN(value);
                }

                return defaultResult;
            }

            function checkPassword(value) {
                var defaultResult = defaultCheck(value.value),
                    compare = document.getElementById(value.getAttribute('data-compare'));

                if (defaultResult) {

                    if (!compare) {
                        return true;
                    }

                    if (value.value !== compare.value) {
                        compare.parentNode.classList.add('invalid');

                        if (compare.parentNode.hasAttribute('data-required')) {
                            compare.parentNode.classList.add('tooltip');
                        }

                        return false;
                    }

                } else {
                    return false;
                }

                return true;
            }

            var value = input.value,
                inputType = input.type,
                result = true,
                condition;

            switch (inputType) {
            case 'email':
                result = defaultCheck(value);

                if (result) {
                    result = emailCheck(value);

                    if (!result) {

                        if (input.parentNode.hasAttribute('data-error')) {
                            input.parentNode.classList.add('tooltip-error');
                        }

                    }
                }

                break;

            case 'number':
                result = numberCheck(value);
                break;

            case 'text':
                result = defaultCheck(value);
                break;

            case 'tel':
                result = defaultCheck(value);
                break;

            case 'select':
                result = selectCheck(input);
                break;
            case 'password':
                result = checkPassword(input);
                break;

            default:
                result = defaultCheck(value);
                break;
            }

            if (result) {
                condition = input.getAttribute('data-condition');

                if (condition) {

                    result = false;

                    if (input.value.trim().split(' ').length > 1) {
                        result = true;
                    }

                }
            }

            return result;
        }

        /**
         * check input
         *
         * @param input
         * @returns {boolean}
         */
        function checkInput(input) {

            var type = input.getAttribute('type'),
                tempControl;

            if (input.tagName !== 'SELECT') {
                if (!(input.offsetWidth > 0 && input.offsetHeight > 0)) {
                    return true;
                }
            } else {
                tempControl = input.previousElementSibling;

                if (!(tempControl.offsetWidth > 0 && tempControl.offsetHeight > 0)) {
                    return true;
                }

                if (parseInt(input.value, 10) === -1) {
                    return false;
                }
            }

            if (input.hasAttribute('disabled') || !input.hasAttribute('required')) {
                return true;
            }

            if (input.hasAttribute('data-check')) {
                checkRequest(input);
            }

            return getErrorMessage(input);
        }

        /**
         * check textarea
         *
         * @param textArea
         * @returns {boolean}
         */
        function checkTextArea(textArea) {
            return checkInput(textArea);
        }

        function hideToolTip(input) {
            setTimeout(function () {
                input.classList.remove('tooltip');
                input.classList.remove('invalid');
                input.classList.remove('tooltip-error');
            }, 3000);
        }

        function hideInvalid(input) {
            setTimeout(function () {
                input.classList.remove('invalid');
            }, 3000);
        }

        function checkRequest(input) {
            var url = input.getAttribute('data-check');

            $.ajax({
                url: url,
                type: 'get',
                data: 'value=' + input.value,
                dataType: 'json',
                success: function (response) {
                    if (!response.result) {
                        input.parentNode.classList.add('invalid');

                        if (input.parentNode.hasAttribute('data-required')) {
                            input.parentNode.classList.add('tooltip');
                        }
                    }
                }
            });
        }

        /**
         * check form
         *
         * @param form
         * @param goTo {boolean}
         * @returns {boolean}
         */
        function check(form, goTo) {

            var inputs = form.querySelectorAll('input[required]'),
                inputsLength = inputs.length,
                textArea = form.querySelectorAll('textarea[required]'),
                textAreaLength = textArea.length,
                select = form.querySelectorAll('select[required]'),
                selectCount = select.length,
                i,
                firstErrorElement,
                result = true,
                checkbox = form.querySelectorAll('[type="checkbox"][required]'),
                checkboxCount = checkbox.length;

            for (i = 0; i < inputsLength; i++) {

                if (!checkInput(inputs[i])) {
                    result = false;
                    inputs[i].parentNode.classList.add('invalid');

                    if (inputs[i].parentNode.hasAttribute('data-required')) {
                        inputs[i].parentNode.classList.add('tooltip');
                    }

                    hideToolTip(inputs[i].parentNode);

                    if (!firstErrorElement) {
                        firstErrorElement = inputs[i];
                    }
                }
            }

            for (i = 0; i < textAreaLength; i++) {
                if (!checkTextArea(textArea[i])) {
                    result = false;
                    textArea[i].parentNode.classList.add('invalid');

                    if (textArea[i].parentNode.hasAttribute('data-required')) {
                        textArea[i].parentNode.classList.add('tooltip');
                    }

                    hideToolTip(textArea[i].parentNode);

                    if (!firstErrorElement) {
                        firstErrorElement = textArea[i];
                    }
                }
            }

            for (i = 0; i < selectCount; i++) {
                if (!checkInput(select[i])) {
                    result = false;
                    select[i].parentNode.classList.add('invalid');

                    if (select[i].parentNode.hasAttribute('data-required')) {
                        select[i].parentNode.classList.add('tooltip');
                    }

                    hideToolTip(select[i].parentNode);

                    if (!firstErrorElement) {
                        firstErrorElement = select[i];
                    }
                }
            }

            for (i = 0; i < checkboxCount; i++) {
                if (!checkbox[i].checked) {
                    result = false;
                    checkbox[i].parentNode.classList.add('invalid');

                    hideInvalid(checkbox[i].parentNode);

                    if (!firstErrorElement) {
                        firstErrorElement = checkbox[i];
                    }
                }
            }

            if (goTo) {
                if (firstErrorElement) {
                    //var wrap = $('.site-wrap'),
                    //    elementPosition = $(firstErrorElement).parent().offset().top;
                    //
                    //wrap.animate({
                    //    scrollTop: wrap.scrollTop() + elementPosition - 106
                    //});
                    $('html,body').animate({
                        scrollTop: $(firstErrorElement).parent().offset().top
                    });
                }
            }

            return result;
        }

        /**
         * check form
         *
         * @public
         * @method check
         * @param form
         * @param goTo {boolean}
         * @returns {boolean}
         */
        this.check = function (form, goTo) {
            return check(form, goTo);
        };

        /**
         * Check input
         *
         * @public
         * @method checkInput
         * @param inputObject
         * @returns {boolean}
         */
        this.checkInput = function (inputObject) {
            return checkInput(inputObject);
        };

        /**
         * Init validate class
         *
         * @method init
         */
        function init() {
        }

        return init();
    };

    return new Validate();

}());